module.exports = __webpack_public_path__ + "img/2021_1_28_skull_angel.9dd6cc5a.jpg";